import { useEffect, useState } from 'react';
import { Modal, ModalContent, ModalFooter } from '@finn-no/troika-react-modal';
import '@finn-no/troika-react-modal/style.css';

interface Props {
    redirectPath?: string;
    open: boolean;
    onCloseModal: () => void;
    onLoginClick: () => void;
}

const createUri = (redirectPath?: string): string => (redirectPath ? `${window.location.origin}${redirectPath}` : window.location.href);

export const LoginModal = ({ redirectPath, open, onLoginClick, onCloseModal }: Props) => {
    const [redirectUrl, setRedirectUrl] = useState('');
    const loginUrl = `/loginForm.html?redirectTo=${encodeURI(redirectUrl)}`;

    useEffect(() => {
        setRedirectUrl(createUri(redirectPath));
    }, []);

    return (
        <Modal isOpen={open} aria-labelledby="login-modal-header">
            <ModalContent>
                <h2 className="u-screen-reader-only" id="login-modal-header">
                    Logg inn for bestille hotell
                </h2>
                <p className="login-modal-text u-caption u-text-center">
                    Logg inn for å bestille hotellrom direkte hos hotellet. Bekreftelsen får du på e-post.
                </p>
            </ModalContent>
            <ModalFooter className="flex flex-column flex-align-center">
                <a href={loginUrl} onClick={onLoginClick} className="button button--cta" style={{ width: 'min(200px, 100%)' }}>
                    Logg inn
                </a>
                <button type="button" onClick={onCloseModal} className="button u-mt16" style={{ width: 'min(200px, 100%)' }}>
                    Lukk
                </button>
            </ModalFooter>
        </Modal>
    );
};
